import { render, staticRenderFns } from "./newDatetime.vue?vue&type=template&id=34347910&scoped=true&"
import script from "./newDatetime.vue?vue&type=script&lang=ts&"
export * from "./newDatetime.vue?vue&type=script&lang=ts&"
import style0 from "./newDatetime.vue?vue&type=style&index=0&id=34347910&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34347910",
  null
  
)

export default component.exports